<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-19",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 19,
      // nextPage: '/questionnaire/section1/20',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Menopause.png'),
        mainTitle: 'Are you familiar with the following tests?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'FSH',
            },{
              text: 'AMH',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
  computed:{
    nextPage(){
      if(this.$store.state.qsData[this.qsNumber].answer.indexOf('FSH') !== -1){
        return '/questionnaire/section1/20'
      }else{
        return '/questionnaire/section2'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
